<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const translateY = ref(props.innerText.length * 26 + 65);
const x2 = ref(963 - props.innerText.length * 26);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1023 30">
  <g id="xiaobiao4" transform="translate(-0.039 -9)">
    <text id="项目执行人性别分布" transform="translate(44.039 32)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
    <line id="直线_697" data-name="直线 697" x2="${x2.value}" transform="translate(${translateY.value} 24.973)" fill="none" stroke="var(--theme-color-1)" stroke-width="1" stroke-dasharray="6"/>
    <path id="路径_5234" data-name="路径 5234" d="M0,0H20.792L24,25.052H0Z" transform="translate(0.039 11.475)" fill="var(--theme-color-1)"/>
    <path id="路径_5235" data-name="路径 5235" d="M128,0h5l3,23h-5Z" transform="translate(-103.961 13.475)" fill="var(--theme-color-1)"/>
    <rect id="矩形_2882" data-name="矩形 2882" width="5" height="25" transform="translate(1018.039 11)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
